(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
      })();
      (function() {
  if (!__sections__["description-tabs"] && !window.DesignMode) return;
  try {
    




      // tabs= document.querySelectorAll('.custom-tab');
      // tabContents= document.querySelectorAll('.custom__tab-content');

      // tabs.forEach(function(tab){
      //     tab.addEventListener('click',function(){

      //         contentId = this.dataset.contentId;
      //         content = document.getElementById(contentId);

      //         tabContents.forEach(function(content){
      //             content.classList.remove('active');
      //         });

      //         tabs.forEach(function(tab){
      //             tab.classList.remove('active');
      //         });

      //         this.classList.add('active');
      //         content.classList.add('active');
      //     });
      // });
    //   document.addEventListener('DOMContentLoaded', function() {
    //   const tabs = document.querySelectorAll('.custom-tab');
    //   const tabContents = document.querySelectorAll('.custom__tab-content');

    //   tabs.forEach(function(tab) {

    //     tab.addEventListener('click', function() {

    //       const contentId = this.dataset.contentId;

    //       const content = document.getElementById(contentId);
    //       console.log(content);
    //       // Remove 'active' class from all content and tabs
    //       tabContents.forEach(function(content) {
    //         content.classList.remove('active');
    //       });

    //       tabs.forEach(function(tab) {
    //         tab.classList.remove('active');
    //       });

    //       // Add 'active' class to the clicked tab and its corresponding content
    //       console.log(this);
    //       this.classList.add('active');
    //       if (content) {
    //         content.classList.add('active');
    //       }
    //     });
    //   });
    // });
    document.addEventListener('DOMContentLoaded', function() {
    const tabs = document.querySelectorAll('.custom-tab');
    const tabContents = document.querySelectorAll('.custom__tab-content');

    tabs.forEach(function(tab) {
      tab.addEventListener('click', function() {
        const contentId = this.dataset.contentId;
        const content = document.getElementById(contentId);

        // Remove 'active' class from all tab parents (li) and content
        tabContents.forEach(function(content) {
          content.classList.remove('active');
        });

        tabs.forEach(function(tab) {
          tab.closest('li').classList.remove('active'); // Remove 'active' class from the parent <li>
        });

        // Add 'active' class to the clicked tab's parent <li> and its corresponding content
        this.closest('li').classList.add('active');
        if (content) {
          content.classList.add('active');
        }
      });
    });
  });

  

  } catch(e) { console.error(e); }
})();
      })();
